import { ShieldCheckIcon } from '@heroicons/react/24/outline';

const FallbackLogicSection = () => {
  return (
    <div className="max-w-3xl mx-auto mb-16 flex items-center gap-4 px-6 py-4 rounded-lg border border-primary/10">
      <ShieldCheckIcon className="w-6 h-6 text-primary flex-shrink-0" />
      <div>
        <p className="text-sm font-bold text-foreground">
          Always Your Home. Always Your Data.
        </p>
        <p className="text-xs text-muted-foreground">If you pause your subscription, you never lose access to your baseline safety checks or check-in history. Your progress stays with you, always. You will be moved to our Limited Access (Free) plan. 

        </p>
      </div>
    </div>);

};

export default FallbackLogicSection;